import React from 'react';
import { useUserContext } from "../../store/user_context";

const UserData = () => {
    const { user } = useUserContext();
    
    return (
        <>
            <section className="main_content">
                <div className="container">
                    <h1 className="page-title">تعديل البيانات</h1>
                    <form action="/user/edit/" className="form-horizontal" method="post">
                        <div className="validation-summary-valid" data-valmsg-summary="true" id="validationSummary">
                            <ul>
                                <li style={{ display: 'none' }}></li>
                            </ul>
                        </div>
                        <div className="form-group">
                            <label>
                                <b>الاسم :</b>
                            </label>
                            <div className="field">
                                <input id="ArabicName" name="ArabicName" type="hidden" value="Muhammad Elknz" />
                                <input id="EnglishName" name="EnglishName" type="hidden" value="" />
                                <input
                                    data-val="true"
                                    data-val-required="The isArabicNationality field is required."
                                    id="isArabicNationality"
                                    name="isArabicNationality"
                                    type="hidden"
                                    value="True"
                                />
                                {user.name}
                            </div>
                        </div>
                        <div className="form-group">
                            <label>
                                <b>الوظيفة :</b>
                            </label>
                            <div className="field">
                                <input
                                    className="form-control"
                                    data-val="true"
                                    data-val-length="The field Title must be a string with a maximum length of 50."
                                    data-val-length-max="50"
                                    data-val-required="يجب إدخال الوظيفة"
                                    id="Title"
                                    name="Title"
                                    type="text"
                                    value={user?.title || ""} 
                                />
                            </div>
                        </div>
                        <input
                            data-val="true"
                            data-val-number="The field BuildingID must be a number."
                            data-val-required="The BuildingID field is required."
                            id="Building_BuildingID"
                            name="Building.BuildingID"
                            type="hidden"
                            value="1"
                        />
                        <div className="form-group">
                            <label>
                                <b>الدور :</b>
                            </label>
                            <div className="field">
                                <select
                                    className="form-control"
                                    data-val="true"
                                    data-val-regex="تأكد من أن قيمة عدد الادوار صحيحه."
                                    data-val-regex-pattern="^[1-6]$"
                                    data-val-required="يجب اختيار الدور"
                                    id="FloorNumber"
                                    name="FloorNumber"
                                    defaultValue={user?.floorNumber}
                                >
                                    <option value="1">B</option>
                                    <option value="2">G</option>
                                    <option value="3">1</option>
                                    <option value="4">2</option>
                                    <option value="5">3</option>
                                </select>
                            </div>
                        </div>
                        <button type="submit" id="save" className="btn btn-primary">
                            حفظ
                        </button>
                        <input id="Email" name="Email" type="hidden" value="{user?.email}" />
                        <input
                            data-val="true"
                            data-val-regex="يجب إدخال ارقام فقط"
                            data-val-regex-pattern="\d+"
                            data-val-required="يجب إدخال رقمك الداخلي بالشركة"
                            id="HindawiID"
                            name="HindawiID"
                            type="hidden"
                            value="1726"
                        />
                        <input id="GoogleName" name="GoogleName" type="hidden" value="{user?.name}" />
                    </form>
                </div>
            </section>
        </>
    );
};

export default UserData;